import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Button, Input } from 'reactstrap';
import HoverImage from 'react-hover-image/build';
import { toast } from 'react-toastify';
import Fax from '../../common/Fax';
import useAxios from 'hooks/useAxios';
import Drawer from 'components/Drawer';
import Comments from '../../common/Comments';
import FaxCross from 'assets/icon/fax-cross.svg';
import FaxIcon from 'assets/icon/fax-blue.svg';
import FaxIconHover from 'assets/icon/fax-blue-hover.svg';
import FaxSentIcon from 'assets/icon/faxSent.svg';
import FaxSentIconHover from "assets/icon/faxSent-hover.svg";
import ErrorBoundary from 'components/ErrorBoundary';
import ReactStrapTable from 'components/reactStrapTable';
import FaxReceivedIcon from 'assets/icon/faxReceived.svg';
import FaxReceivedIconHover from "assets/icon/FaxReceivedIcon-Hover.svg";
import commonColumns, { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import AttachIcon from 'assets/icon/icon-icon-options-attachment.svg';
import AttachHoverIcon from 'assets/icon/icon-icon-options-attachment_hover.svg';
import { cloneDeep } from 'lodash';
import ToolTip from 'react-tooltip-lite';
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import FaxViewer from 'components/FaxViewer';
import { ModuleAccess } from 'utils/moduleaccess';

let chckedIds = [];
let rxNumbers = [];
let providersIds = [];


let tableDataBackup = [],
  rowForEdit = {},
  updatedFields = {};

const PatientDetailsTable = (props) => {
  let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: 'patientFirstName',
    order: 'desc',
    filters: [],
  };
  const {
    onClaimSelect, onRxSelect, refresh, onProviderSelect, faxRefresh, module, orgId, patientId, tenantID, coveredEntity
  } = props;

  const API = useAxios();
  // const { patientId, tenantID } = useParams();
  const [isOpen, setOpen] = useState(false);
  const [faxDrawer, setFaxDrawer] = useState(false);
  const [data, setData] = useState(tableDataBackup);
  const [totalSize, setTotalSize] = useState(0);
  const [claim, setClaim] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [initFilter, setInitFilter] = useState(initialFilters);
  const [hasTouched, setTouched] = useState('');
  const [hasStatusChanged, setSelectedStatus] = useState('');
  const [pdfModal, setPdfModel] = useState(false);
  const [fax, setFaxDetail] = useState({});
  const [selectedTenentID, setSelectedTenentID] = useState({});
  // console.log(initFilter,"initfilter")

  const hasPermission = (code) => {
    return ModuleAccess("CLM", code);
    //return (module && module.actions.indexOf(code) != -1)
  }

  const fetchPatientDetails = async (filters = {}, hasFilter) => {
    let pageFilter = { ...filters };
    if (hasFilter) {
      pageFilter.filters = [...initialFilters.filters, ...filters.filters];
      initialFilters.filters = filters.filters;
    } else {
      initialFilters = { ...initialFilters, ...filters };
    }
    try {
      const { data } = await API.post(
        `/${tenantID}/Claim/PatientClaims/${parseInt(patientId)}`,
        pageFilter
      );
      if (data) {
        tableDataBackup = data.items;
        setData(data.items);
        setTotalSize(data.totalRecords);
      }
      else {
        tableDataBackup = []
        setData([])
        setTotalSize(0)
      }
    } catch (error) { }
  };

  useEffect(() => {

    setData([]);
    chckedIds = [];
    rxNumbers = [];
    fetchPatientDetails({
      currentPage: 1,
      pageSize: 10,
      orderBy: '',
      order: '',
      filters: [],
    });
    setSelectedTenentID({ "tenantID": tenantID });
  }, [refresh]);

  const toggleDrawer = (claim = {}) => {
    setClaim(claim);
    setOpen(!isOpen);
  };

  const toggleDrawerFax = (claim = {}) => {
    setClaim(claim);
    setFaxDrawer((pre) => !pre);
  };

  const onChange = (claim) => {
    const { claimID, rxNumber, providerID } = claim;
    const index = chckedIds.indexOf(claimID);
    const index2 = rxNumbers.indexOf(rxNumber);
    const providerIndex = providersIds.indexOf(providerID);
    if (chckedIds.length === 0) {
      chckedIds.push(claimID);
      rxNumbers.push(rxNumber);
      providersIds.push(providerID);
    } else {
      if (index >= 0) {
        chckedIds.splice(index, 1);
        rxNumbers.splice(index2, 1);
        providersIds.splice(providerIndex, 1);
      } else {
        chckedIds.push(claimID);
        rxNumbers.push(rxNumber);
        providersIds.push(providerID);
      }
    }
    setSelectedIds([...chckedIds]);
    onClaimSelect([...chckedIds]);
    onRxSelect([...rxNumbers]);
    onProviderSelect([...providersIds]);
  };

  const renderEditButton = (rowData) => {
    if (hasPermission('ED'))
      return <Button
        className='text-primary p-0 text-decoration-none'
        color='link'
        onClick={() => editRow(rowData)}
      >
        <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt='' />
      </Button>
  }


  const renderCheckbox = (claim) => {
    if (hasPermission('CSM')) {
      const filter = selectedIds.filter((item) => item === claim.claimID);
      return (
        <Input
          onChange={() => onChange(claim)}
          type='checkbox'
          className='me-2 mt-0'
          value={filter.length > 0}
          checked={filter.length > 0}
        />);
    }
  }

  const editRow = (rowData, isEdit = true) => {
    let tempData = [...tableDataBackup];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.claimID === rowData?.claimID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    setTouched('');
    setSelectedStatus('');
    updatedFields = {};
    tableDataBackup = tempData;
    setData(tempData);
  };




  const attachFile = (claim) => {
    const { canFax, suppressFlag, isFaxSent, isFaxReceived } = claim;
    const filter = selectedIds.filter((item) => item === claim.claimID);


    if (claim.isEdit) {
      return (
        <div className='d-flex align-items-center'>
          <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={saveUpdateRow}
          >
            <HoverImage
              key='SaveIcon'
              src={SaveIcon}
              hoverSrc={SaveHoverIcon}
              alt=''
            />
          </Button>
          <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => editRow(claim, false)}
          >
            <HoverImage
              key='CancelIcon'
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt=''
            />
          </Button>
        </div>
      );
    } else {
      return (
        <div className='d-flex align-items-center'>

          {renderCheckbox(claim)}
          {renderEditButton(claim)}

          <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => toggleDrawer(claim)}
            hidden={!ModuleAccess("CLM", "ACC")}
          >
            <HoverImage src={AttachIcon} hoverSrc={AttachHoverIcon} alt='' />
          </Button>
          {canFax ? (
            <Button
              className='text-primary p-0 text-decoration-none faxicon-small'
              color='link'
              onClick={() => toggleDrawerFax(claim)}
              disabled={suppressFlag === 'Y'}
            >
              <HoverImage
                key="FaxIcon"
                src={FaxIcon}
                hoverSrc={FaxIconHover}
                alt=""
              />
              {/* <img src={FaxIcon} alt='' className='me-2' /> */}
            </Button>
          ) : (
            <div className='p-0 ms-0'>
              <img src={FaxCross} alt='' />
            </div>
          )}
          {claim.isFaxSent && (
            <div className='p-0 ms-0'>

              <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => previewFaxInfo(claim, 'outboundfax')}

              >
                <HoverImage
                  key='FaxSentIcon'
                  src={FaxSentIcon}
                  hoverSrc={FaxSentIconHover}
                  alt=''
                />
              </Button>
              {/*<img src={FaxSentIcon} alt='fax sent' />*/}
            </div>
          )}
          {claim.isFaxReceived && (
            <div className='0'>
              <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => previewFaxInfo(claim, 'inboundfax')}

              >
                <HoverImage
                  key='FaxReceivedIcon'
                  src={FaxReceivedIcon}
                  hoverSrc={FaxReceivedIconHover}
                  alt=''
                />
              </Button>
              {/*<img src={FaxReceivedIcon} alt='fax sent' />*/}


            </div>
          )}
        </div>
      );
    }
  };

  const previewFaxInfo = async (row, faxdirection) => {
    try {
      let payload = {};
      payload.FaxDetailID = faxdirection === "outboundfax" ? row.outboundLastFaxId : row.inboundLastFaxId;
      const result = await API.post(
        `/${tenantID}/fax/patientfaxinfo/${row.coveredEntityID}`, payload);
      if (result) {
        setPdfModel(!pdfModal);
        setFaxDetail(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const togglePdfModal = () => {
    setPdfModel(!pdfModal);
  };
  useEffect(() => {
    if (isOpen == true) {
      setOpen(false)
    }
    if (faxDrawer == true) {
      setFaxDrawer(false)
    }
    if (pdfModal == true) {
      setPdfModel(false)
    }

  }, [orgId])

  const formatter = (row) => {
    const { patientFirstName, ndc, drugName, qtyDispensed, providerFirstName, providerLastName, providerSpecialty, dateRXWritten, totalPaid, dispensingFee, ceReceivable, drugCost340B, profitLoss, dateofService, providerComments } = row;
    return (

      <ToolTip content={(
        <div className='tip-list-info'>
          <p>NDC <span> {ndc} </span></p>
          <p>Drug Name<span> {drugName} </span></p>
          <p>Dispensed Qty <span> {qtyDispensed} </span></p>
          <p>Date Rx Written <span> {dateFormate(dateRXWritten)} </span></p>
          <p>Date of Service <span> {dateFormate(dateofService)} </span></p>
          <p>Total Paid <span> {currencyFormat(totalPaid)} </span></p>
          <p>Dispensing Fee <span> {currencyFormat(dispensingFee)} </span></p>
          <p>CE Receivable  <span> {currencyFormat(ceReceivable)} </span></p>
          <p>340B Drug Cost <span> {currencyFormat(drugCost340B)} </span></p>
          <p>Profit/Loss <span> {currencyFormat(profitLoss)} </span></p>
          <p>Provider Name <span> {providerFirstName + " " + providerLastName} </span></p>
          <p>Provider Specialty<span> {providerSpecialty} </span></p>
          <p>Provider Comments <span> {cellRendererCheck(providerComments)} </span></p>

        </div>
      )}
        direction="down"
        tagName="span"
        className="target"
        tipContentClassName="">
        <span>
          {patientFirstName}
        </span>
      </ToolTip>
    );
  };


  const saveUpdateRow = async () => {
    try {
      const postData = {
        claimID: rowForEdit['claimID'],
        statusID: updatedFields['claimStatusID']
          ? parseInt(updatedFields['claimStatusID'])
          : '',
        reasonDesc: updatedFields['reasonDesc'] || rowForEdit['reasonDesc'],
      };
      if (
        !hasStatusChanged ||
        !postData.reasonDesc ||
        !postData.claimID ||
        !postData.statusID
      ) {
        setTouched(true);
        return;
      }
      const { data } = await API.post(
        `/${tenantID}/Claim/UpdateStatus`,
        postData
      );
      if (data) {
        toast.success('Updated Successfully!');
        fetchPatientDetails(initFilter);
      } else {
        console.log(' error ', data);
      }
    } catch (err) {
      toast.error('An error occurred');
      console.error(err);
    }
  };

  const updateRowValue = (value, col) => {
    updatedFields[col] = value;
    if (col === 'claimStatusID') {
      setSelectedStatus(parseInt(rowForEdit.claimStatusID) !== parseInt(value));
    }
  };

  const cellEditRender = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        col={col}
        formatterType={formatterType}
        onChange={updateRowValue}
        hasTouched={hasTouched}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
        requiredFields={['statusList', 'text']}
      />
    );
  };

  // let copyCommonColumns = cloneDeep(commonColumns);

  let copyCommonColumns = [
    {
      dataField: 'patientFirstName',
      text: 'Patient First Name',
      cellRenderer: (rowData) => cellRendererCheck(rowData.patientFirstName),
      sort: true,
      width: 175,
      show: true,
      inputType: 'text',
      // hideColFilter: true,
    },
    {
      dataField: "patientLastName",
      text: "Patient Last Name",
      sort: true,
      width: 175,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.patientLastName),
    },
    {
      dataField: "patientDOB",
      text: "Patient DOB",
      sort: true,
      width: 120,
      show: true,
      inputType: "date",
      // hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.patientDOB),
    },
    {
      dataField: "medicalRecordNumber",
      text: "Medical Record Number",
      sort: true,
      width: 160,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.medicalRecordNumber),
    },
    {
      dataField: "claimStatus",
      text: "Claim Status",
      sort: false,
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimStatus),
      width: 130,
      show: true,
      edit: true,
      inputType: "text",
      hideColFilter: true,
    },
    {
      dataField: "reasonDesc",
      text: "Reason",
      sort: false,
      cellRenderer: (rowData) => cellRendererCheck(rowData.reasonDesc),
      width: 240,
      show: true,
      edit: true,
      inputType: "text",
      hideColFilter: true,
    },
    {
      dataField: "rxNumber",
      text: "RX Number",
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.rxNumber),
    },
    {
      dataField: "refillNumber",
      text: "Refill Number",
      sort: true,
      width: 110,
      show: true,
      inputType: "number",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.refillNumber),
    },
    {
      dataField: "dateRXWritten",
      text: "Date Rx Written",
      cellRenderer: (rowData) => dateFormate(rowData.dateRXWritten),
      sort: false,
      width: 120,
      show: true,
      inputType: "date",
      hideColFilter: true,
    },
    {
      dataField: "dateofService",
      text: "Date of Service",
      cellRenderer: (rowData) => dateFormate(rowData.dateofService),
      sort: true,
      width: 120,
      show: true,
      inputType: "date",
      // hideColFilter: true,
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: true,
      width: 110,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.ndc),
    },
    {
      dataField: "drugName",
      text: "Drug Name",
      sort: false,
      width: 160,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.drugName),
    },
    {
      dataField: "qtyDispensed",
      text: "Qty Dispensed",
      sort: false,
      width: 120,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.qtyDispensed),
    },
    {
      dataField: "daysSupply",
      text: "Days Supply",
      sort: false,
      width: 100,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.daysSupply),
    },
    {
      dataField: "gcnSequenceNumber",
      text: "GCN Sequence Number",
      sort: false,
      width: 150,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.gcnSequenceNumber),
    },
    {
      dataField: "manufacturerName",
      text: "Manufacturer Name",
      sort: false,
      width: 160,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.manufacturerName),
    },
    {
      dataField: "drugStatusDesc",
      text: "Drug Status Desc",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.drugStatusDesc),
    },
    {
      dataField: "claimType",
      text: "Claim Type",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimType),
    },
    {
      dataField: "claimSubType",
      text: "Claim Sub Type",
      sort: true,
      width: 120,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimSubType),
    },
    {
      dataField: "sourceReason",
      text: "Source Reason",
      sort: true,
      width: 120,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.sourceReason),
    },
    {
      dataField: "totalPaid",
      text: "Total Paid",
      sort: false,
      width: 125,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.totalPaid),
      className: "text-end",
    },
    {
      dataField: "dispensingFee",
      text: "Dispensing Fee",
      sort: false,
      width: 125,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.dispensingFee),
      className: "text-end",
    },
    {
      dataField: "ceReceivable",
      text: "CE Receivable",
      sort: false,
      width: 125,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.ceReceivable),
      className: "text-end",
    },
    {
      dataField: "drugCost340B",
      text: "Drug Cost 340B",
      sort: false,
      width: 125,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.drugCost340B),
      className: "text-end",
    },
    {
      dataField: "profitLoss",
      text: "Profit/Loss",
      sort: false,
      width: 125,
      textAlign: "right",
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.profitLoss),
      className: "text-end",
    },
    {
      dataField: "rcsFeeAmt",
      text: "RCS Fee Amount",
      cellRenderer: (rowData) => currencyFormat(rowData.rcsFeeAmt),
      sort: false,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: true,
      className: "text-end",
    },
    {
      dataField: "netProfit",
      text: "Net Savings",
      cellRenderer: (rowData) => currencyFormat(rowData.netProfit),
      sort: false,
      width: 144,
      show: true,
      inputType: "number",
      className: "text-end",
      hideColFilter: true,
    },
    {
      dataField: "hasVisit",
      text: "Eligible Visit",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.hasVisit),
      hideColFilter: true,
    },
    {
      dataField: "providerNPI",
      text: "Provider NPI",
      sort: true,
      width: 150,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerNPI),
    },
    {
      dataField: "providerFirstName",
      text: "Provider First Name",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerFirstName),
    },
    {
      dataField: "providerLastName",
      text: "Provider Last Name",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerLastName),
    },
    {
      dataField: "providerSpecialty",
      text: "Provider Specialty",
      sort: false,
      width: 180,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerSpecialty),
      hideColFilter: true,
    },
    {
      dataField: "providerStatus",
      text: "Provider Status",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerStatus),
      hideColFilter: true,
    },
    {
      dataField: "faxNumber",
      text: "Fax Number",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.faxNumber),
    },
    {
      dataField: "phoneNumber",
      text: "Phone Number",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.phoneNumber),
    },
    {
      dataField: "faxCount",
      text: "Fax Count",
      sort: false,
      width: 130,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.faxCount),
    },
    {
      dataField: "pharmacyNPI",
      text: "Pharmacy NPI",
      sort: true,
      width: 150,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.pharmacyNPI),
    },
    {
      dataField: "pharmacyName",
      text: "Pharmacy Name",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.pharmacyName),
    },
    {
      dataField: "thirdPartyAdminID",
      text: "Third Party Admin",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.thirdPartyAdminID),
    },
    {
      dataField: "bin",
      text: "BIN",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.bin),
    },
    {
      dataField: "pcn",
      text: "PCN",
      sort: false,
      width: 130,
      show: true,
      hideColFilter: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.pcn),
    },
    {
      dataField: "groupNumber",
      text: "Group Number",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.groupNumber),
    },
    {
      dataField: "secondaryBIN",
      text: "Secondary BIN",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryBIN),
    },
    {
      dataField: "secondaryPCN",
      text: "Secondary PCN",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryPCN),
    },
    {
      dataField: "secondaryGroup",
      text: "Secondary Group",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryGroup),
    },

    {
      dataField: "createdDate",
      text: "Created Date",
      sort: true,
      width: 160,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.createdDate),
    },
    {
      dataField: "createdByID",
      text: "Created By",
      sort: false,
      width: 125,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.createdBy),
      hideColFilter: true,
    },
    {
      dataField: "claimStatusChangeDate",
      text: "Status Change Date",
      sort: false,
      width: 125,
      show: true,
      hideColFilter: true,
      inputType: "date",
      cellRenderer: (rowData) => dateFormate(rowData.claimStatusChangeDate),
    },
    {
      dataField: "statusChangedBy",
      text: "Status Changed By",
      sort: false,
      width: 125,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.statusChangedBy),
      hideColFilter: true,
    },
    {
      dataField: "completedDate",
      text: "Completed Date",
      sort: false,
      width: 125,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.completedDate),
    },
    {
      dataField: "completedBy",
      text: "Completed By",
      sort: false,
      width: 125,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.completedBy),
      hideColFilter: true,
    },
    {
      dataField: "invoicedDate",
      text: "Invoiced Date",
      sort: false,
      width: 125,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.invoicedDate),
    },
    {
      dataField: "invoicedBy",
      text: "Invoiced By",
      sort: false,
      width: 125,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.invoicedBy),
      hideColFilter: true,
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 125,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.modifiedDate),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 125,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.modifiedBy),
      hideColFilter: true,
    },
    {
      dataField: "claimID",
      text: "Claim ID",
      sort: true,
      width: 125,
      show: true,
      inputType: "number",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimID),
    },
    {
      dataField: "sourceClaimID",
      text: "Source Claim ID",
      sort: false,
      width: 150,
      show: true,
      hideColFilter: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.sourceClaimID),
    },
    {
      dataField: "claimReferenceID",
      text: "Claim Reference ID",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimReferenceID),
    },
  ];

  copyCommonColumns[4].cellRenderer = (row, col) =>
    cellEditRender(row, col, 'statusList');
  copyCommonColumns[5].cellRenderer = (row, col) =>
    cellEditRender(row, col, 'comments');

  var patientObj = {
    dataField: 'patientFirstName',
    text: 'Patient First Name',
    cellRenderer: (rowData) => formatter(rowData),
    sort: true,
    width: 144,
    show: true,
    inputType: 'text',

  };

  copyCommonColumns.splice(0, 1, patientObj);

  const columns = [
    {
      dataField: 'attachement',
      text: 'Options',
      cellRenderer: (rowData) => attachFile(rowData),
      width: 120,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    ...copyCommonColumns,
  ];

  const supressFlagObj = {
    dataField: 'suppressFlag',
    text: 'Suppress Flag',
    sort: false,
    hideColFilter: true,
    width: 130,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.suppressFlag),
  };

  columns.join();
  columns.splice(33, 0, supressFlagObj);

  const handlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setInitFilter(filter);
      let colFilterOn = { ...filter, filters: colChangedFilter };
      fetchPatientDetails(colFilterOn, true);
    } else {
      setInitFilter(filter);
      fetchPatientDetails(filter);
    }
  };

  const handleSort = (filter, hasColFilter) => {
    setInitFilter(filter);
    if (hasColFilter) {
      fetchPatientDetails(filter, true);
    } else {
      fetchPatientDetails(filter);
    }
  };

  const handleSearchColumnFilters = (columnFilters) => {
    if (columnFilters.length) {
      let filter = {
        ...initFilter,
        filters: [...columnFilters],
        currentPage: 1,
      };
      setInitFilter(filter);
      fetchPatientDetails(filter, true);
    }
  };

  const handleFilterCancel = () => {
    initialFilters.filters = [];
    initialFilters.pageSize = initFilter.pageSize;
    initialFilters.order = initFilter.order;
    initialFilters.orderBy = initFilter.orderBy;
    setInitFilter(initialFilters);
    fetchPatientDetails(initialFilters);
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setInitFilter(filter);
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return fetchPatientDetails(colFilterOn, true);
    }
    setInitFilter(filter);
    fetchPatientDetails(filter);
  };

  return (
    <div className=''>
      <div
        className='table-card filter-table position-relative border-0'
        fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
      >
        <ReactStrapTable
          id='patient-details-table'
          fixedColumn
          height={50 * 5}
          width={1200}
          columns={columns}
          data={data}
          handleSort={handleSort}
          loader
          filters={initFilter}
          onSearchColumnFilters={handleSearchColumnFilters}
          onFilterCancel={handleFilterCancel}
          hasPagination
          pageSize={initFilter.pageSize}
          onPageSizeChange={onPageSizeChange}
          currentPage={initFilter.currentPage}
          totalRecords={totalSize}
          onPageChange={handlePageChange}
        // datafilter={true}

        />
      </div>
      <Drawer
        direction='end'
        isOpen={isOpen}
        toggle={toggleDrawer}
        title='Add Claim Comment'
        size="lg"
      >
        <ErrorBoundary>
          <Comments rxNumber={claim?.rxNumber} claimData={claim} onClose={toggleDrawer} tenantID={tenantID} patientId={patientId} coveredEntityID={coveredEntity} />
        </ErrorBoundary>
      </Drawer>
      <Drawer
        direction='end'
        isOpen={faxDrawer}
        toggle={toggleDrawerFax}
        title='Send Fax'
        size="lg"
      >
        <ErrorBoundary>
          <Fax claim={claim} onClose={toggleDrawerFax} refresh={faxRefresh} tenantID={tenantID} patientId={patientId} coveredEntityID={coveredEntity} />
        </ErrorBoundary>
      </Drawer>

      <Drawer
        direction='end'
        isOpen={pdfModal}
        toggle={togglePdfModal}
        title='Fax View'
        size="lg"
      >


        <FaxViewer selectedCoveredEntity={selectedTenentID} hasReadOnly={true} fax={fax}
          hideComments={true} toggle={togglePdfModal}></FaxViewer>
      </Drawer>

      {/* <FaxViewer
        fax={fax}
        hasReadOnly={true}
        isOpen={pdfModal}
        toggle={togglePdfModal}
        selectedCoveredEntity={selectedTenentID}
        hideComments={true}
      /> */}


    </div>



  );
};

export default PatientDetailsTable;


